import type { FaireProductEntity } from "../../entity_types/product";

export const p_kr2f333ty7: FaireProductEntity = {
  token: "p_kr2f333ty7",
  type: "product",
  name: "Woon Peanuts & Seamoss",
  brandToken: "b_th428x9zzy",
  brandName: "Woon",
  imageUrl: "https://cdn.faire.com/fastly/7fdfeccc1f74785ab978e5ecf4a0aebeb06c41899840d1bbf5c87856f3a2eb6d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a9522f3dcea3762284b33f720bd3e03769d5727ebb2a3a76121c4609895fb780.jpeg",
    "https://cdn.faire.com/fastly/782514644f2b6b9f8e0abfc76c1ec527683c5f568186d27c887999a8bbd07480.jpeg",
    "https://cdn.faire.com/fastly/ce220790f4a885d9dc36b41c174a28ffd30877e3d36f191e8d02af23f494089f.jpeg",
    "https://cdn.faire.com/fastly/46405a54c0d30d357dc8b1edf3ae3d062125a4f5577075e6065733d699f0c67c.jpeg",
    "https://cdn.faire.com/fastly/f31979bc4014f521e4ef7ea0dec248b5b7a516f792f5df9170dbe73ea3f94558.jpeg"
  ],
  priceDollars: 5.6,
  description: "Grandma June's favorite Shanghainese drinking snack, passed down to Mama Fong. A blend of in-house roasted peanuts and dehydrated, roasted sea moss. Once you try them, you'll never want another beer without them.\n\n\n3 month shelf life",
  tags: [],
  msrpDollars: 8,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:01.135Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
